export const heartedFeedIds = (state) => {
  return state.heartedFeedIds;
};
export const heartedFeedCommentIds = (state) => {
  return state.heartedFeedCommentIds;
};
